import axios from 'axios'
import { getCookie } from '@/pkg/cookie'

const token = getCookie('resource')

const identityClientPrivate = axios.create({
  baseURL: process.env.VUE_APP_PRIVATE_OAUTH_URL,
})

let identityClient
if (process.env.NODE_ENV === 'development') {
  identityClient = axios.create({
    baseURL: process.env.VUE_APP_OAUTH_URL,
    headers: { Authorization: `Bearer ${token}` },
  })
} else {
  identityClient = axios.create({
    baseURL: process.env.VUE_APP_OAUTH_URL,
    withCredentials: true,
  })
}

export function getPrivateClient() {
  return identityClientPrivate
}

export function getClient() {
  return identityClient
}
